var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFarewell(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6,
    fill: "#E03B3F"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2563 18.4938L19.9963 19.7538L17.4762 17.2337L16.2337 18.4762L18.7537 20.9962L17.4938 22.2562C17.2225 22.5275 17.415 23 17.8088 23H21.5625C21.8075 23 22 22.8075 22 22.5625V18.8088C22 18.415 21.5275 18.2225 21.2563 18.4938ZM22 13.1912V9.4375C22 9.1925 21.8075 9 21.5625 9H17.8088C17.415 9 17.2225 9.4725 17.5025 9.74375L18.7625 11.0037L14.65 15.125H8.875C8.39375 15.125 8 15.5188 8 16C8 16.4812 8.39375 16.875 8.875 16.875H15C15.2275 16.875 15.455 16.7787 15.6213 16.6213L20.005 12.2463L21.265 13.5062C21.5275 13.7775 22 13.585 22 13.1912Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFarewell);
export default __webpack_public_path__ + "static/media/farewell.7cda25ccb131eaef1ed4342318d58d0a.svg";
export { ForwardRef as ReactComponent };